import { render, staticRenderFns } from "./FormatQuoteClose.vue?vue&type=template&id=49db65f1&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatQuoteClose.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FormatQuoteClose.vue
// module id = 1719
// module chunks = 1